import React from "react";
import "../Leadership/LeadershipFounderMessage.css";
import founderPhoto from "../../Assets/career/internship.png";
import waveBg from "../../Assets/background-wave.png";
import dotPattern from "../../Assets/leadership/Ellipse 244.png";
import vcnrLogo from "../../Assets/vcnr-logo-white.png";
import { useNavigate } from 'react-router-dom';

const CareerTexts = () => {
  const navigate = useNavigate();
  return (
    <section className="Leaderfounder-section">
      {/* <img src={waveBg} alt="Background Waves" className="Leaderbg-wave" /> */}
      <div className="Leaderfounder-container">
        <div className="Leaderfounder-left">
                    <h2 className="Leaderfounder-heading">Internships & <br />
Young Leaders</h2>
          <h4 className="Leaderfounder-name">
            Step In. <br />Stand Out.
          </h4>
          <p className="Leaderfounder-text">
 VCNR’s Young Leaders Program offers internships and early-career opportunities across sectors. Interns at our company contribute to real projects, present ideas to seniors, and experience startup energy inside a structured environment.          </p>
          <p className="Leaderfounder-text">
With exposure to real-world challenges in tech, sustainability, healthcare, and more, our internship program is a great opportunity for future leaders.          </p>
         <h4 className="Leaderfounder-name1">At VCNR, we don’t just grow businesses—<br />
we grow people."</h4>
<br />
          <button
            className="explore-btn"
            onClick={() => navigate('/Career')}
          >
            Apply for Internships
          </button>

        </div>
        <div className="Leaderfounder-right">
          <div className="Leaderfounder-image-wrapper">
            <img src={dotPattern} alt="Dot pattern" className="Leaderdot-pattern" />
            <img src={founderPhoto} alt="Founder" className="Leaderfounder-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerTexts;
